import ofrDocumentTemplateMock from './ofrDocumentTemplateList.mock'

const ofrDocumentTemplateDetails = ofrDocumentTemplateMock.data[0]

export default ofrDocumentTemplateDetails
